

import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';


export interface QcReasonMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;  
}
export interface QcReasonMst {
    id?:number;
    qcStatus:string;
    qcDescription:string;  
   
    createdIp:string;
 
    createdBy:number;
    createdDate:Date
    tenantId:any;
    branchId:any;
      
    parameters?: QcReasonMstParameter[];
    links?: any;
}

export abstract class QcReasonMstData { 
    abstract list(url: string): Observable<any[]>;
    abstract create(url: string,data: any): Observable<any>;
    abstract update(url: string,data: any): Observable<any>;
    abstract delete(url: string): Observable<any>;
}
